<script>
export default {
  name: "NotFoundView",
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$auth.isAuthenticated()) {
        return next({ name: "my-plane" });
      }

      next({ name: "login" });
    });
  },
  computed: {
    isAuthenticated() {
      return this.$auth.isAuthenticated();
    },
  },
  render() {
    return null;
  },
};
</script>
